import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);
const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;


export function getTodayDate() {
  return dayjs().tz(userTimezone).utc().format("YYYY-MM-DD");
}

export function getConvertDate(date: any) {
  return dayjs(date).tz(userTimezone).utc();
}

export function getCustomSubtractDate(days: number) {
  return dayjs().tz(userTimezone).utc().subtract(days, "day").format("YYYY-MM-DD");
}
export function getCustomSubtractDateHours(days: number) {
    return dayjs().tz(userTimezone).utc().subtract(days, "day").format("YYYY-MM-DD HH:mm:ss");
  }

  export function getCustomSubtractMonthHours(days: number) {
    return dayjs().tz(userTimezone).utc().subtract(days, "month").format("YYYY-MM-DD HH:mm:ss");
  }

export function getCustomAddDate(days: number) {
    return dayjs().tz(userTimezone).utc().add(days, "day").format("YYYY-MM-DD");
  }
  export function getCustomAddDateHours(days: number) {
    return dayjs().tz(userTimezone).utc().add(days, "day").format("YYYY-MM-DD HH:mm:ss");
  }
  

  export function getWeekDate() {
    return dayjs().tz(userTimezone).utc().day();
  }


  export function getUTCDate(date: any) {
    return dayjs().tz(userTimezone).utc()
  }